import React from "react";
import Layout from "../../../Layout";
import SearchUserStatus from "./SearchUserStatus";
import HeaderReports from "../../HeaderReports";
import ListUserStatus from "./ListUserStatus";

const UserStatus = () => {

  return (
    <Layout>
      <HeaderReports />
      <ListUserStatus />
      <SearchUserStatus />
    </Layout>
  );
};


export default UserStatus;
